import {deleteObject, listAll, ref} from 'firebase/storage';
import {firebaseStorage} from '../../../config/firebase';

/**
 * Deletes all files under a folder whose filename (after the last /) starts with the given prefix.
 * Use when the same logical file can exist with different extensions (e.g. avatar.jpg, avatar.png).
 * @param folderPath - The storage folder path (e.g. "public/uid" or "private/uid")
 * @param filenamePrefix - The filename prefix without extension (e.g. "avatar", "click")
 */
export default async function deleteStorageFilesByPrefix(folderPath: string, filenamePrefix: string): Promise<void> {
  const folderRef = ref(firebaseStorage, folderPath);
  const result = await listAll(folderRef);
  const toDelete = result.items.filter((item) => {
    const fileName = item.name.split('/').pop() ?? '';
    return fileName.startsWith(filenamePrefix);
  });
  await Promise.all(toDelete.map((item) => deleteObject(item)));
}
